export enum PhysiologicalDataTableColumn {
  DATE = 'date',
  SYS = 'sys',
  DIA = 'dia',
  HR = 'hr',
  BP_TYPE = 'bpType',
}
